import React from 'react';
import {Route, Switch} from 'react-router-dom';
import RoomList from '../containers/RoomList/RoomList';
import RoomDetails from '../containers/RoomDetails/RoomDetails';
import NavBar from './NavBar'
import RoomForm from "../containers/RoomForm/RoomForm";
import HotelForm from '../containers/HotelForm/HotelForm';
import HotelDetails from "../containers/HotelDetails/HotelDetails";
import LoginForm from '../containers/LoginForm/LoginForm';
import RegisterForm from '../containers/RegisterForm/RegisterForm';
import Logout from '../containers/Logout/Logout';
import HotelList from '../containers/HotelList/HotelList';
import NotFoundPage from "../components/NotFoundPage/NotFoundPage";
import MyReservations from "../containers/MyReservations/MyReservations";
import EditRoomForm from "../containers/EditRoomForm/EditRoomForm";
import ReservationConfirmationPage from "../containers/Confirmation/ReservationConfirmationPage";
import EditHotelForm from "../containers/EditHotelForm/EditHotelForm";
import HomePage from "../containers/HomePage/HomePage";
import UpdatePassword from "../containers/UpdatePassword/UpdatePassword";
import RatingForm from "../containers/RatingForm/RatingForm";
import SearchForm from "../containers/SearchForm/SearchForm";
import RatingList from "../containers/RatingList/RatingList";
import ChangePassword from "../containers/ChangePassword/ChangePassword";
import ResetPasswordForm from "../containers/ResetPasswordForm/ResetPasswordForm";

function Layout() {
    return (
        <div>
            <NavBar/>
                    <Switch>
                        <Route path="/" exact component={HomePage}/>
                        <Route path="/login" exact component={LoginForm}/>
                        <Route path="/rooms/:id" exact component={RoomDetails}/>
                        <Route path="/modify-room/:id" exact component={EditRoomForm}/>
                        <Route path="/modify-hotel/:id" exact component={EditHotelForm}/>
                        <Route path="/register-room" exact component={RoomForm}/>
                        <Route path="/register-hotel" exact component={HotelForm}/>
                        <Route path="/hotels/:id" exact component={HotelDetails}/>
                        <Route path="/register-user" exact component={RegisterForm}/>
                        <Route path="/logout" exact component={Logout}/>
                        <Route path="/hotel-list" exact component={HotelList}/>
                        <Route path="/my-reservations" exact component={MyReservations}/>
                        <Route path="/rooms/:id/confirm" exact component={ReservationConfirmationPage}/>
                        <Route path="/rooms" exact component={RoomList}/>
                        <Route path="/search" exact component={SearchForm}/>
                        <Route path="/ratings/ratingform/:id" exact component={RatingForm}/>
                        <Route path="/ratings/:id" exact component={RatingList}/>
                        <Route path="/updatepassword" exact component={UpdatePassword}/>
                        <Route path="/changePassword" exact component={ChangePassword}/>
                        <Route path="/resetPassword" exact component={ResetPasswordForm}/>

                        <Route path="" component={NotFoundPage} />
                    </Switch>
            </div>
    )
}

export default Layout;


// WEBPACK FOOTER //
// ./src/common/Layout.jsx